import * as React from "react";
import type { SVGProps } from "react";
const SvgReviewAssetHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 432 288"
    fill="none"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_1624_6551)">
      <rect
        x={-40}
        y={-126.32}
        width={513}
        height={432}
        fill="url(#pattern0_1624_6551)"
      />
    </g>
    <defs>
      <pattern
        id="pattern0_1624_6551"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_1624_6551"
          transform="matrix(.00028 0 0 .00033 -.061 0)"
        />
      </pattern>
      <clipPath id="clip0_1624_6551">
        <path
          d="M0 38.4c0-13.44 0-20.16 2.62-25.3C4.92 8.6 8.59 4.92 13.1 2.62 18.24 0 24.96 0 38.4 0h355.2c13.44 0 20.16 0 25.3 2.62 4.51 2.3 8.18 5.97 10.48 10.48C432 18.24 432 24.96 432 38.4v211.2c0 13.44 0 20.16-2.62 25.3-2.3 4.51-5.97 8.18-10.48 10.48-5.14 2.62-11.86 2.62-25.3 2.62H38.4c-13.44 0-20.16 0-25.3-2.62-4.51-2.3-8.18-5.97-10.48-10.48C0 269.76 0 263.04 0 249.6z"
          fill="white"
        />
      </clipPath>
      <image
        id="image0_1624_6551"
        width={4032}
        height={3024}
        preserveAspectRatio="none"
        xlinkHref="/prompts/review-asset-home.jpg"
      />
    </defs>
  </svg>
);
export default SvgReviewAssetHome;
